import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@xref/ngx';
import { SettingsMenuBtnModule } from '../settings-menu-btn/settings-menu-btn.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GetStartedFormComponent } from './get-started-form.component';

@NgModule({
  declarations: [GetStartedFormComponent],
  imports: [
    CommonModule,
    SettingsMenuBtnModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule
  ],
  exports: [GetStartedFormComponent],
  providers: []
})
export class GetStartedFormModule {}
